import {isPlatformBrowser} from "@angular/common";
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {
  type ApplicationConfig,
  inject,
  PLATFORM_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from "@angular/core";
import {
  provideClientHydration,
  withEventReplay,
  withHttpTransferCacheOptions,
  withI18nSupport,
} from "@angular/platform-browser";
import {provideRouter, withComponentInputBinding, withInMemoryScrolling} from "@angular/router";
import {firstValueFrom} from "rxjs";
import {type IWebAppConfig, WEB_APP_CONFIG} from "../common/app-config";
import {routes} from "./app.routes";
import {authInterceptorFn} from "./services/api/auth.interceptor";
import {WebApiService} from "./services/api/web/web-api.service";

let loadedWebAppConfig: IWebAppConfig;

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: "enabled",
        anchorScrolling: "enabled",
      })),
    provideClientHydration(
      withEventReplay(),
      withI18nSupport(),
      withHttpTransferCacheOptions({
        includePostRequests: true,
        includeRequestsWithAuthHeaders: true,
      })),
    provideHttpClient(withInterceptors([authInterceptorFn])),
    provideAppInitializer(async () => {
      if (isPlatformBrowser(inject(PLATFORM_ID))) // web app config provided in app.config.server.ts
        loadedWebAppConfig = await firstValueFrom(inject(WebApiService).getAppConfig());
    }),
    {
      provide: WEB_APP_CONFIG,
      useFactory: (platformId: object): IWebAppConfig => {
        if (isPlatformBrowser(platformId)) return loadedWebAppConfig;
        // provided in app.config.server.ts
        return inject(WEB_APP_CONFIG, {skipSelf: true});
      },
      deps: [PLATFORM_ID],
    },
  ],
};
